import { useNavigate } from '@tanstack/react-router';

import { usePermissions } from '@/features/permissions';
import { defaultRosterView } from '../flowsheets/CareRoster';
import { AssistantPreviewLink } from './workbench/PreviewLink';
import { type AssistantCommand, PatientsAssistant } from './PatientsAssistant';

/** Shared patient lookup and roster exploration, plus permission-scoped page actions. */
export function WorkspaceAssistant({ title, commands = [] }: { title: string; commands?: AssistantCommand[] }) {
  const navigate = useNavigate();
  const { can } = usePermissions();
  return (
    <div className="flex flex-wrap items-center gap-2">
      <AssistantPreviewLink />
      <PatientsAssistant
        title={title}
        view={defaultRosterView}
        onRoster={({ view }) => void navigate({ to: '/patients', search: { roster: view } })}
        commands={[
          ...commands,
          ...(can('read_patient') ? [{ label: 'Open Patients', run: () => void navigate({ to: '/patients' }) }] : []),
          ...(can('read_encounter')
            ? [
                {
                  label: 'Open Calendar',
                  run: () => void navigate({ to: '/calendar', search: { month: undefined, assigned_to: undefined } }),
                },
              ]
            : []),
          ...(can('read_imaging') || can('prepare_imaging')
            ? [{ label: 'Open Imaging', run: () => void navigate({ to: '/imaging' }) }]
            : []),
        ]}
      />
    </div>
  );
}
